import { ManageApplicationPayload, DeleteApplicationPayload } from "../../slices/manage-application/Types";

export const manageApplicationSagaActionTypes = {
  callManageApplicationSaga: "callManageApplicationSaga",
  callCheckApplicationIDSaga: "callCheckApplicationIDSaga",
  callDeleteApplicationIDSaga: "callDeleteApplicationIDSaga",
};

export const manageApplicationSagaAction: (payload: ManageApplicationPayload) => {
  type: string;
  payload: ManageApplicationPayload;
} = (payload) => {
  return {
    type: manageApplicationSagaActionTypes.callManageApplicationSaga,
    payload: payload,
  };
};

export const checkApplicationIDSagaAction: (applicationId: string) => {
  type: string;
  payload: string;
} = (applicationId) => {
  return {
    type: manageApplicationSagaActionTypes.callCheckApplicationIDSaga,
    payload: applicationId,
  };
};

export const deleteApplicationIDSagaAction: (payload: DeleteApplicationPayload) => {
  type: string;
  payload: DeleteApplicationPayload;
} = (payload) => {
  return {
    type: manageApplicationSagaActionTypes.callDeleteApplicationIDSaga,
    payload: payload,
  };
};